import { render } from "./UserDropDownComp.vue?vue&type=template&id=06742c50&scoped=true"
import script from "./UserDropDownComp.vue?vue&type=script&lang=js"
export * from "./UserDropDownComp.vue?vue&type=script&lang=js"

import "./UserDropDownComp.vue?vue&type=style&index=0&id=06742c50&scoped=true&lang=css"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06742c50"]])

export default __exports__